import { z } from "zod";
import { twinDeviceIdSchema, twinDeviceRegisterInputSchema, twinDeviceRegisterResponseSchema, twinDeviceRemoveResponseSchema } from "../twin-devices.js";
import { defineOperation } from "./http.js";
/** Native clients only: the person's phone and signed-in organisation; the tenant retains ownership checks. */
export const TWIN_DEVICE_OPERATIONS = {
    registerNotificationDevice: defineOperation({
        operationId: "twin.notifications.devices.register", method: "PUT",
        path: "/api/workspace/notifications/devices/{deviceId}", audience: "public",
        requiredScope: "twin.write", rateClass: "create",
        request: { params: z.object({ deviceId: twinDeviceIdSchema }).strict(), body: twinDeviceRegisterInputSchema },
        response: { kind: "json", status: 200, schema: twinDeviceRegisterResponseSchema },
        swiftSdk: { method: "registerNotificationDevice" },
        openapi: { summary: "Register your phone for notifications",
            description: "Registers the caller's phone for the Twin's alert pushes, for the organisation it is signed in to, which must be the request's own (409 otherwise). Registering again replaces its token, environment, version and organisation. A push carries ids only (the organisation, the kind, the Inbox item), and goes only to devices signed in to its notification's organisation. For native clients.",
            responseDescription: "Device registered", errors: [400, 403, 409],
        },
    }),
    removeNotificationDevice: defineOperation({
        operationId: "twin.notifications.devices.remove", method: "DELETE",
        path: "/api/workspace/notifications/devices/{deviceId}", audience: "public",
        requiredScope: "twin.write", rateClass: "create",
        request: { params: z.object({ deviceId: twinDeviceIdSchema }).strict() },
        response: { kind: "json", status: 200, schema: twinDeviceRemoveResponseSchema },
        swiftSdk: { method: "removeNotificationDevice" },
        openapi: { summary: "Remove your phone from notifications",
            description: "Removes the caller's phone, whichever organisation it was registered for, so it receives no more pushes: on sign-out, and before switching organisation. Removing a device that isn't registered succeeds. For native clients.",
            responseDescription: "Device removed", errors: [400, 403],
        },
    }),
};
